import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useState, } from 'react';
import clsx from 'clsx';
import { Box, ClickAwayListener, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import { Translation } from '../Translation';
import clickableCustomTooltipStyles from './clickableCustomTooltip.styles';
const ClickableCustomTooltip = memo(({ children, placement = 'right', className = '', translationId, tooltipType, hasContent = true, }) => {
    const styles = clickableCustomTooltipStyles();
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const openTooltip = useCallback((e) => {
        e.stopPropagation();
        setTooltipOpen(true);
    }, []);
    return (_jsx(Box, { component: "span", className: className, children: _jsx(ClickAwayListener, { onClickAway: () => setTooltipOpen(false), children: _jsx(Tooltip, { arrow: false, placement: placement, title: children, open: tooltipOpen, classes: {
                    tooltip: styles.tooltipContainer,
                    arrow: styles.tooltipArrow,
                }, children: _jsx(IconButton, { onClick: openTooltip, "data-test": `tooltip:${tooltipType}`, className: clsx({
                        [styles.tooltipIconButton]: true,
                        [styles.tooltipSvgIconButton]: !translationId,
                    }), disableRipple: true, disabled: !hasContent, children: translationId ? (_jsx(Translation, { id: translationId }, void 0)) : (_jsx(InfoIcon, { color: 'primary', viewBox: '0 0 24 24', className: styles.tooltipSvg }, void 0)) }, void 0) }, void 0) }, void 0) }, void 0));
});
export default ClickableCustomTooltip;
//# sourceMappingURL=ClickableCustomTooltip.js.map